





















import Vue from 'vue';
import { mapGetters } from 'vuex';

export default Vue.extend({
    name: 'About',
    computed: {
        ...mapGetters('app', {
            appName: 'getAppName',
            copyrightLink: 'getCopyrightLink',
            devLink: 'getDevLink',
        }),
    },
});
